"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updatePrintableLayerPosition;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
function updatePrintableLayerPosition(project, action) {
  const printableGroupIndex = project.printableGroups.findIndex(pg => !!pg.printables.find(p => p.id === action.printableId));
  if (printableGroupIndex === -1) {
    return (0, either_1.left)(new Error('Could not find printable group'));
  }
  const printableIndex = project.printableGroups[printableGroupIndex].printables.findIndex(p => p.id === action.printableId);
  if (printableIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find printable for printableId: ${action.printableId}`));
  }
  const layerIndex = project.printableGroups[printableGroupIndex].printables[printableIndex].layers.findIndex(layer => layer.id === action.layerId);
  if (layerIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find layer for layerId: ${action.layerId}`));
  }
  const printableUpdated = (0, Printable_1.updatePrintableVersion)(project.printableGroups[printableGroupIndex].printables[printableIndex], action.timestamp);
  const targetedLayer = (0, lodash_clonedeep_1.default)(printableUpdated.layers[layerIndex]);
  const layerMoving = typeof action.x === 'number' || typeof action.y === 'number';
  const layerResizing = typeof action.width === 'number' || typeof action.height === 'number';
  const updateValid = layerMoving && targetedLayer.userCanMove || layerResizing && targetedLayer.userCanResize;
  if (!updateValid) {
    return (0, either_1.left)(new Error(`Action is invalid for layer layerMoving: ${layerMoving}, userCanMove: ${targetedLayer.userCanMove}, layerResizing: ${layerResizing}, userCanResize: ${targetedLayer.userCanResize}`));
  }
  targetedLayer.x = action.x !== undefined ? action.x : targetedLayer.x;
  targetedLayer.y = action.y !== undefined ? action.y : targetedLayer.y;
  // @ts-ignore: accessing targeted layer width
  targetedLayer.width = action.width || targetedLayer.width;
  // @ts-ignore: accessing targeted layer height
  targetedLayer.height = action.height || targetedLayer.height;
  if ((0, EditableTextLayer_1.isFilledEditableTextLayer)(targetedLayer)) {
    targetedLayer.userData.assetId = (0, EditableTextLayer_1.generateTextAssetId)(targetedLayer.width, targetedLayer.height, targetedLayer.userData.content || '', printableUpdated.surface);
  }
  printableUpdated.layers[layerIndex] = targetedLayer;
  project.printableGroups[printableGroupIndex].printables[printableIndex] = printableUpdated;
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: [project, printableUpdated]
  });
}